/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspostcategory_Save_Failed2Inputs */

const vi_cmspostcategory_save_failed2 = /** @type {(inputs: Cmspostcategory_Save_Failed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không lưu được chuyên mục. Kiểm tra mạng rồi thử lại.`)
};

/**

* @param {Cmspostcategory_Save_Failed2Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspostcategory_save_failed2 = /** @type {((inputs?: Cmspostcategory_Save_Failed2Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspostcategory_Save_Failed2Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspostcategory_save_failed2(inputs)
});
export { cmspostcategory_save_failed2 as "cmsPostCategory_save_failed" }